import endpoints from './endpoints';

export interface IEndpoint {
  url: string;
  scope: string;
}

/**
 * getScopeFromUrl takes a url as a string and returns the associated scopes. If there
 * are no scopes it will return an empty array.
 *
 * @param {(string | undefined)} url
 * @return {string[]}
 */
export function getScopeFromUrl(url: string | undefined): string[] {
  if (!url) return [];

  const endpointArray = Object.values(endpoints);
  const endpoint = endpointArray.find((element) => url.includes(element.url));

  if (endpoint) return [endpoint.scope];
  return [];
}
